import './chips.stylesheet.css';

const Chips = props => {

	let handleClickEvent = (e, idx) => {
		e && e.hasOwnProperty('preventDefault') && e.preventDefault();
		if (!props.disabled) {
			props.hasOwnProperty('removeChipHandler') && props.removeChipHandler(idx);
		}
	}

	return (
		<div className="chip" onClick={e => handleClickEvent(e, props.idx)} style={{ textTransform: 'capitalize' }}>
			{props.name}
			<span className="closebtn" >&times;</span>
		</div>
	)
}

export default Chips;